import styled from 'styled-components'
import Ast from './ast'

export default styled(Ast)`
  > div > * {
    color: #000;
  }
`
